const COLUMN_ERROR_TYPES = [
  "columns_missing",
  "unexpected_column",
  "duplicated_column"
];

export function hasValidExtension(file) {
  return !!file && /\.(xlsx|xls)$/i.test(String(file.name));
}

export function clearInput(input) {
  if (input) input.value = "";
}

function isObject(value) {
  return !!value && typeof value === "object" && !Array.isArray(value);
}

export function splitErrors(errors) {
  const columnErrors = [];
  const rowErrors = [];
  (errors || []).forEach(function(item) {
    if (item && COLUMN_ERROR_TYPES.indexOf(item.type) !== -1) {
      columnErrors.push(item);
    } else {
      rowErrors.push(item);
    }
  });
  return { columnErrors, rowErrors };
}

export function isAnalysis(body) {
  if (!isObject(body)) return false;
  if (!Array.isArray(body.dependenciasNuevas)) return false;
  if (!Array.isArray(body.errors)) return false;
  if (!isObject(body.filas)) return false;
  const validNames = body.dependenciasNuevas.every(function(item) {
    return isObject(item) && typeof item.nombreDependencia === "string";
  });
  if (!validNames) return false;
  if (splitErrors(body.errors).columnErrors.length === 0) {
    return (
      typeof body.filas.validas === "number" &&
      typeof body.filas.total === "number"
    );
  }
  return true;
}

export function dependenciesToCreate(analysis) {
  return analysis.dependenciasNuevas.map(function(item) {
    return item.nombreDependencia;
  });
}

export function classifyError(err) {
  const response = err && err.response;
  if (!response) {
    const isHttp = !!(err && (err.request || err.isAxiosError));
    return { kind: isHttp ? "network" : "unknown", message: "", analysis: null };
  }
  const status = response.status;
  const data = response.data;
  if (status === 401 || status === 403) {
    return { kind: "auth", message: "", analysis: null, status };
  }
  if (status >= 500) {
    return { kind: "server", message: "", analysis: null, status };
  }
  if (status === 400 && isAnalysis(data)) {
    return { kind: "analysis", message: "", analysis: data, status };
  }
  if (status === 400 && isObject(data) && typeof data.message === "string") {
    return { kind: "message", message: data.message, analysis: null, status };
  }
  return { kind: "unknown", message: "", analysis: null, status };
}



// WEBPACK FOOTER //
// ./src/components/climan/upload/analysis.js